import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import isPlainObject from 'lodash/isPlainObject';
import isEmpty from 'lodash/isEmpty';
import ProductDescription from '~/components/molecules/Product/ProductDescription.vue';
import ProductCharacteristics from '~/components/molecules/Product/ProductCharacteristics.vue';
import ProductMedia from '~/components/molecules/Product/ProductMedia.vue';
export default {
  name: 'ProductInformation',
  components: {
    ProductCharacteristics: ProductCharacteristics,
    ProductDescription: ProductDescription,
    ProductMedia: ProductMedia
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasCharacteristics: function hasCharacteristics() {
      return isPlainObject(this.product.parameters);
    },
    hasDescriptions: function hasDescriptions() {
      return !isEmpty(this.product.additionalInformation.additionalContent) || !isEmpty(this.product.description.main) || !isEmpty(this.product.additionalInformation.infoCompDescription) || !isEmpty(this.product.description.line) || !isEmpty(this.product.line);
    },
    hasMediaOrLogos: function hasMediaOrLogos() {
      return !isEmpty(this.product.additionalInformation.video) || !isEmpty(this.product.additionalInformation.specificityLogo);
    }
  }
};